import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/src/views/privacy/components/privacy-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/src/views/privacy/components/privacy-header/index.tsx");
